import type { EnhancedDeal, TimberProject } from '../types';
import { parseLegacyTitle } from './projectName';

export type StructureMentionProjectOption = {
  dealId: string;
  label: string;
};

export function buildStructureMentionProjectOptions(
  timberProjects: TimberProject[],
  dealsById: Map<string, EnhancedDeal>,
): StructureMentionProjectOption[] {
  const out: StructureMentionProjectOption[] = [];
  const seen = new Set<string>();
  for (const p of timberProjects) {
    if (p.status === 'completed' || !p.dealId) continue;
    const dealId = p.dealId.trim();
    if (!dealId || seen.has(dealId)) continue;
    seen.add(dealId);
    const deal = dealsById.get(dealId);
    const num = (deal?.projectNumber || '').trim();
    const numberDisplay = num ? (num.startsWith('#') ? num : `#${num}`) : '';
    const descriptor = (
      (deal?.descriptor || '').trim()
      || parseLegacyTitle(deal?.title || '').descriptor
      || p.name
      || 'Project'
    ).trim();
    const label = [numberDisplay, descriptor].filter(Boolean).join(' ').trim() || descriptor;
    out.push({ dealId, label });
  }
  out.sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }));
  return out;
}

export function filterProjectOptionsForQuery(
  options: StructureMentionProjectOption[],
  query: string,
): StructureMentionProjectOption[] {
  const q = query.trim().toLowerCase();
  if (!q) return options.slice(0, 40);
  return options.filter((o) => o.label.toLowerCase().includes(q)).slice(0, 40);
}
